import React from 'react';
import { Form } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import confirm from 'antd/es/modal/confirm';
import dayjs from 'dayjs';
import { CalendarEvent, useUpdateCalendarEventMutation } from 'entities/calendar';

type FormValues = Omit<CalendarEvent, 'startDate' | 'endDate'> & {
  dateRange: [dayjs.Dayjs, dayjs.Dayjs];
};

interface UpdateCalendarEventFormProps {
  eventData: CalendarEvent;
  calendarId: string;
  form: FormInstance<FormValues>;
  instance: ReturnType<typeof confirm>;
  dom: React.ReactNode;
}

const UpdateCalendarEventForm: React.FC<UpdateCalendarEventFormProps> = ({
  eventData,
  calendarId,
  form,
  instance,
  dom,
}) => {
  const { mutateAsync: updateEventMutation } = useUpdateCalendarEventMutation(calendarId);

  return (
    <Form
      key={eventData.id}
      form={form}
      preserve={false}
      layout="vertical"
      requiredMark={false}
      autoComplete="off"
      data-testid="update-form"
      onFinish={(formData) => {
        const { dateRange, name, exclusionType, workingHours } = formData;
        const sendedData =
          exclusionType === 'NON_WORKING_DAY'
            ? {
                id: eventData.id,
                startDate: dateRange[0].format('YYYY-MM-DD'),
                endDate: dateRange[1].format('YYYY-MM-DD'),
                name: name.trim(),
                exclusionType,
              }
            : {
                id: eventData.id,
                startDate: dateRange[0].format('YYYY-MM-DD'),
                endDate: dateRange[1].format('YYYY-MM-DD'),
                name: name.trim(),
                exclusionType,
                workingHours: workingHours as number,
              };

        instance.update({ okButtonProps: { loading: true } });
        updateEventMutation(sendedData, {
          onSettled: () => instance.destroy(),
          onError: () => instance.update({ okButtonProps: { loading: false } }),
        });
      }}
    >
      {dom}
    </Form>
  );
};

export { UpdateCalendarEventForm };
